import { useMemo } from "react";
import FeatureFlagContext, {
  FeatureFlagContextType,
} from "./FeatureFlagContext";
import useUser from "../UserProvider/useUser";

function FeatureFlagProvider({ children }: { children: React.ReactNode }) {
  const { user } = useUser();

  const value: FeatureFlagContextType = useMemo(() => {
    return {
      featureFlags: {
        checklist: !!user?.email?.includes("@macawhq.com"),
        sectionWritingVersionSelector: !!(
          user?.email?.includes("@macawhq.com") ||
          user?.email?.includes("@refindable.com")
        ),
        framerPlugin: !!user?.email?.includes("@macawhq.com"),
      },
    };
  }, [user?.email]);

  return (
    <FeatureFlagContext.Provider value={value}>
      {children}
    </FeatureFlagContext.Provider>
  );
}

export default FeatureFlagProvider;
